export type ServiceFindings = 'Yes' | 'None'
export type ServiceWorkCompletion = 'Yes' | 'No'

export const SERVICE_REPORT_SITES = ['Bergen', 'Mongstad', 'Ågotnes'] as const
export type ServiceReportSite = (typeof SERVICE_REPORT_SITES)[number]
export const SERVICE_DEFAULT_SITE: ServiceReportSite = 'Bergen'

export const SERVICE_WORK_PERFORMED_OPTIONS = [
  'Venting på utførelse av arbeid',
  'Venting på tilkomst',
  'Ekstra grunnet reparasjon',
  'Ekstra grunnet testing',
  'Ekstra grunnet inspeksjon',
  'Service',
  'Ytterligere service',
  'Reparasjon',
  'Ytterligere reparasjon',
  'Transport',
  'Se kommentar',
] as const

export const SERVICE_SPARE_PARTS_OPTIONS = [
  'Slinger',
  'Slingbrikkefeste',
  'Skilt',
  'Strips',
  'Klistremerke',
  'Aerosol',
  'Maling',
  'Olje',
  'Deler',
  'Wireline, deler',
] as const

export interface ServiceEntryItem {
  value: string
  details: string
  comment: string
}

export interface ServiceReportFormData {
  testDate: string
  testSite: string
  duration: string
  reportNumber: string
  serialNumber: string
  objectDescription: string
  issuedBy: string
  company?: string
  report_code?: string | null
  workPerformedItems: ServiceEntryItem[]
  sparePartsItems: ServiceEntryItem[]
  findings: ServiceFindings | ''
  workCompletion: ServiceWorkCompletion | ''
  recommendedActions: string
  inlineImages: string[]
}

export const emptyServiceEntry = (): ServiceEntryItem => ({
  value: '',
  details: '',
  comment: '',
})
